import { Stack, Text, Flex } from "@chakra-ui/react";
import { PaginationItem } from "./PaginationItem";
import Results from "./Results";

const siblingsCount = 1;

function generatePagesArray(from, to) {
  return [...new Array(to - from)]
    .map((_, index) => {
      return from + index + 1;
    })
    .filter((page) => page > 0);
}

export function Pagination({
  meta,
  viewing = 0,
  currentPage = 1,
  onPageChange,
}) {
  const previousPages =
    currentPage > 1
      ? generatePagesArray(currentPage - 1 - siblingsCount, currentPage - 1)
      : [];

  const nextPages =
    !!meta?.last_page && currentPage < meta.last_page
      ? generatePagesArray(
          currentPage,
          Math.min(currentPage + siblingsCount, meta.last_page)
        )
      : [];

  return (
    <Flex
      w="100%"
      height={["32px", "32px", "24px"]}
      mt={["32px", "32px", "24px"]}
      align="center"
      justify={["center", "center", "space-between"]}
    >
      <Flex display={["none", "none", "flex"]}>
        <Results actual={viewing} total={meta?.total} />
      </Flex>
      {!!meta && meta?.total > 0 ? (
        <Stack direction="row" spacing="2">
          {currentPage > 1 + siblingsCount && (
            <>
              <PaginationItem onPageChange={onPageChange} number={1} />
              {currentPage > 2 + siblingsCount && (
                <Text color="gray.300" width="8" textAlign="center">
                  ...
                </Text>
              )}
            </>
          )}

          {previousPages.length > 0 &&
            previousPages.map((page) => {
              return (
                <PaginationItem
                  onPageChange={onPageChange}
                  key={page}
                  number={page}
                />
              );
            })}

          <PaginationItem
            onPageChange={onPageChange}
            number={currentPage}
            isCurrent
          />

          {nextPages.length > 0 &&
            nextPages.map((page) => {
              return (
                <PaginationItem
                  onPageChange={onPageChange}
                  key={page}
                  number={page}
                />
              );
            })}

          {!!meta?.last_page &&
            currentPage + siblingsCount < meta.last_page && (
              <>
                {currentPage + 1 + siblingsCount < meta.last_page && (
                  <Text color="gray.300" width="8" textAlign="center">
                    ...
                  </Text>
                )}
                <PaginationItem
                  onPageChange={onPageChange}
                  number={meta.last_page}
                />
              </>
            )}
        </Stack>
      ) : null}
    </Flex>
  );
}